import { useGraphContext } from "../GraphContext";
import pako from 'pako';

const useHandleQuery = () => {
  let baseURL;
  if (window.location.hostname === 'vuca-prod.simbaanalytics-dev.rio.cloud') {
    baseURL = 'https://2xsaaphhz4.execute-api.eu-west-1.amazonaws.com/prod';
  } else if (window.location.hostname === 'vuca-prod.simbaanalytics-prod.rio.cloud') {
    baseURL = 'https://2xsaaphhz4.execute-api.eu-west-1.amazonaws.com/prod';
  } else if (window.location.hostname === 'vuca-dev.simbaanalytics-dev.rio.cloud') {
    baseURL = 'https://jutwh4kwbk.execute-api.eu-west-1.amazonaws.com/dev';
  } else if (window.location.hostname === '8jmq9udcvt.eu-west-1.awsapprunner.com') {
    baseURL = 'https://jutwh4kwbk.execute-api.eu-west-1.amazonaws.com/dev';
  } else {
    baseURL = 'http://localhost:5000'; 
  }


  const { filters, updateGraphData } = useGraphContext();
  
  const handleQuery = async ({ selectedValues, file }) => {
    console.log('in handle query', selectedValues);

    const formData = new FormData();
    formData.append('data', JSON.stringify(selectedValues)); // Append JSON data
    if (file) {
        formData.append('file', file); // Append CSV file if it exists
    }

    // Retrieve the access token from localStorage
    const accessToken = localStorage.getItem('idToken');

    try {
        const response = await fetch(`${baseURL}/submit`, {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: `Bearer ${accessToken}`, // Attach the access token
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const contentEncoding = response.headers.get('Content-Encoding');
        let result;

        if (contentEncoding === 'gzip') {
            // If the response is gzip-compressed, decompress it
            const compressedData = await response.arrayBuffer();
            const decompressedData = pako.ungzip(new Uint8Array(compressedData), { to: 'string' });
            result = JSON.parse(decompressedData);
        } else {
            // If the response isn't gzip-compressed, parse it as JSON directly
            result = await response.json();
        }

        updateGraphData(result);
        console.log('Response data:', result);
    } catch (error) {
        console.error('Error in handleQuery:', error);
    }
};


  // console.log('graph_data',graphData);

  return handleQuery;
};

export default useHandleQuery;

